// Login.js
import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";
import logo from "../assets/images/Reveknew_Logo_Colour_and_Black.png";
import ImplicitCallback from "./Authentication";
import Loading from "../Components/Loading";
import { useLocation } from "react-router-dom"
import "../Styles/pages/login.scss";

export default function Login() {
  const { t } = useTranslation("common");
  const { keycloak, initialized } = useKeycloak();
  const location = useLocation();

  const login = () => {
    // keycloak.login();  // Trigger Keycloak login
    keycloak.login({
      redirectUri: window.location.href, // Dynamically redirect after login
    });
  };

  useEffect(() => {
    if (initialized && !keycloak.authenticated) {
      const params = new URLSearchParams(location.search);
      const autoSignIn = params.get("autoSignIn");
      if (autoSignIn === "true") {
        login()
      }
    }
    // eslint-disable-next-line
  }, [initialized, keycloak.authenticated, location.search])

  if (!initialized) {
    return <div style={{ height: "100vh" }}><Loading /></div>
  }

  if (!keycloak.authenticated) {
    return (
      <div className="login-body login-page">
        <div className="login-panel" aria-hidden="true"></div>

        <div className="login-content">
          <img src={logo} alt="Reveknew" />
          <p>{t("login.welcome_text")}</p>

          <Button label={t("login.login_label")} onClick={login} />
        </div>
      </div>
    );
  } else {
    return <ImplicitCallback />;
  }
}
